<!-- Menu Referente  -->
<div class="container">
  <div class="row m-5 d-flex justify-content-center">
    <div class="col-4">
      <div class="card card-pointer p-3 border border-primary border-5" (click)="rutas('/create-solicitud-servicio')">
        <img src="../../assets/logo/crear.png" class="card-img-top" alt="..." srcset="">
        <br>
        <div class="d-flex justify-content-center">
          <h5 class="fw-bold">Crear solicitud</h5>
        </div>
      </div>
    </div>

    <div class="col-4">
      <div class="card card-pointer p-3 border border-primary border-5" (click)="rutas('/seguimiento-solicitudes-referente')">
        <img src="../../assets/logo/lista.png" class="card-img-top" alt="..." srcset="">
        <br>
        <div class="d-flex justify-content-center">
          <h5 class="fw-bold">Seguimiento solicitud</h5>
        </div>
      </div>
    </div>
  </div>
</div>